import React from "react";
import { formatDistanceWithSuffix } from "tsi-common-react/src/apps/retail/helpers";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location";
import { formatPhoneNumber } from "tsi-common-react/src/utils/format";
import { t } from "ttag";

import hoursIcon from "../../img/retail-locator/hours-icon.png";
import locationIcon from "../../img/retail-locator/location-icon.png";
import phoneIcon from "../../img/retail-locator/phone-icon.png";
import tpStoreTile from "../../img/retail-locator/tp-store-tile.jpg";

interface IProps {
    store: IRetailStoreWithDistance;
}

export const FlagshipStore = (props: IProps): React.ReactNode => {
    // Convert distance from meters to miles
    const phoneInUSFormat = props.store.phone
        ? formatPhoneNumber(props.store.phone)
        : "";
    return (
        <div className="pdp-modal-tpstore pdp-modal__block">
            <h5 className="pdp-modal__subtitle">
                {t`Your Closest Tempur-Pedic Store`}
            </h5>
            <div className="pdp-modal-tpstore__img-wrapper">
                <img
                    className="pdp-modal-tpstore__img responsive-img"
                    src={tpStoreTile}
                />
                <div className="pdp-modal-tpstore__miles">
                    {formatDistanceWithSuffix(props.store.distance)}
                </div>
            </div>
            <div className="pdp-modal-tpstore__info">
                <h4 className="pdp-modal-tpstore__name">{props.store.name}</h4>
                <div className="pdp-modal-tpstore__address">
                    <div>
                        <img src={locationIcon} alt={t`Location Icon`} />
                        {/* TODO(i18n): Hard-coding address format assumes US convention. Use locale-aware address formatting that handles different country formats (e.g., "city state" vs "state, city" vs "city postal-code") */}
                        <span className="pdp-modal-tpstore__marker al-more-ways-to-buy-directions">
                            {props.store.address}&nbsp;
                            {props.store.address2}&nbsp;
                            {props.store.city}, {props.store.state}
                        </span>
                    </div>
                    {phoneInUSFormat && (
                        <div>
                            <img src={phoneIcon} alt={t`Phone Icon`} />
                            <a
                                href={`tel:${props.store.phone}`}
                                className="pdp-modal-tpstore__phone pdp-modal__link"
                            >
                                {phoneInUSFormat}
                            </a>
                        </div>
                    )}
                    <div>
                        <img src={hoursIcon} alt={t`Hours Icon`} />
                        <div className="pdp-modal-tpstore__time">
                            {/*TODO: WTH? Why is this hardcoded? */}
                            {t`Today`}: {t`10AM`} - {t`9PM`}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
